import React, { useEffect } from 'react';
import { CognitoUserAmplify } from '@aws-amplify/ui';
import { AuthEventData } from '@aws-amplify/ui';
import Logo from 'components/Logo/Logo';
import { t } from '../../helpers/componentHelper';

import './NavPanel.scss';

type NavOption = {
  id: string;
  content: JSX.Element;
};

type NavPanelComponetProps = {
  showNav: boolean;
  options: NavOption[];
  loggedInUser: CognitoUserAmplify;
  userTier: string;
  signOut: (data?: AuthEventData) => void;
};

function NavPanel({ showNav, options, loggedInUser, userTier, signOut }: NavPanelComponetProps) {
  const [version, setVersion] = React.useState<string>('');
  useEffect(() => {
    // Fetch the file from the public directory
    fetch('/version.txt')
      .then((response) => response.text())
      .then((text) => {
        // Split text by newline to get an array of lines
        const linesArray = text.split(/\r?\n/);
        setVersion(linesArray[0]); // Set the first line as the version
      });
  }, []);

  return (
    <div className="navPanel">
      {showNav && (
        <div className="navPanel__show--body">
          <div className="navPanel__user--narrow">
            <div>{`${t('nav.loggedInUser')}`}</div>
            <div className={'navPanel__user-info'}>
              <span className={'email'}>{loggedInUser?.attributes?.email}</span>
              <span className={'tier'}>{userTier}</span>
            </div>
            <div className={'signout'}>
              <a onClick={() => signOut()}>({`${t('nav.signOut')}`})</a>
              <span className={'version'}>{`${version}`}</span>
            </div>
          </div>
          {options &&
            options.map((option) => (
              <div key={option.id} id={option.id}>
                {option.content}
              </div>
            ))}
          <div className="navPanel__show--footer">
            <Logo />
          </div>
        </div>
      )}
      <div className="navPanel__show--wide-body">
        <div className="navPanel__user">
          <div>{`${t('nav.loggedInUser')}`}</div>
          <div className={'navPanel__user-info'}>
            <span className={'email'}>{loggedInUser?.attributes?.email}</span>
            <span className={'tier'}>{userTier}</span>
          </div>
          <div className={'signout'}>
            <a onClick={() => signOut()}>({`${t('nav.signOut')}`})</a>
            <span className={'version'}>{`${version}`}</span>
          </div>
        </div>
        {options &&
          options.map((option) => (
            <div id={option.id} key={option.id}>
              {option.content}
            </div>
          ))}
        <div className="navPanel__show--footer">
          <Logo />
        </div>
      </div>
    </div>
  );
}

export default NavPanel;
